<template>
  <geo-json-source ref="source" :data="safeGeoJsonData" :source-id="sourceId">
    <layer-group
      :hide-layer="hideLayer"
      :layers="layers"
      :filter="filter"
      :before="props.before"
      @click="handleClick"
    >
      <template #hover="{ feature }">
        <ResourceHover :hovered-feature="feature" />
      </template>
    </layer-group>
  </geo-json-source>
</template>

<script setup lang="ts">
import { GeoJSONFeature, MapMouseEvent, SymbolLayerSpecification } from 'mapbox-gl'
import { computed } from 'vue'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import ResourceHover from '../hovers/ResourceHover.vue'
import { resourcePinStyle } from './styles/resource-pin'
import { useResourcesGeoJSON } from '@/components/field-view-next/composables/useResourcesGeoJSON'

const props = defineProps<{
  layerId: string
  sourceId: string
  hiddenFeatureIds?: (number | string)[]
  before?: string
  hideLayer?: boolean
}>()

const emits = defineEmits<{
  (event: 'click', data: GeoJSONFeature[], eventData: MapMouseEvent)
}>()
const handleClick = (data: GeoJSONFeature[], eventData: MapMouseEvent) => {
  emits('click', data, eventData)
}

const layers: SymbolLayerSpecification[] = [
  {
    id: props.layerId,
    source: props.sourceId,
    type: 'symbol',
    layout: {
      ...resourcePinStyle.layout,
    },
    paint: {
      ...resourcePinStyle.paint,
    },
  },
]

const { data: geoJsonData } = useResourcesGeoJSON()

// Provide a fallback for when data is undefined
const safeGeoJsonData = computed(
  () => geoJsonData.value || { type: 'FeatureCollection', features: [] },
)

const filter = computed(() => {
  const filterArray: any[] = ['all']
  const ids = props.hiddenFeatureIds || []
  if (ids.length > 0) {
    filterArray.push(['!', ['in', ['id'], ['literal', ids]]])
  }
  return filterArray
})
</script>
